import React from "react";
import {
  FormGroup,
  Label,
  Input,
  FormText,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import PropTypes from "prop-types";
import {
  GEOJSON_STYLES,
  LEGEND_KEY,
  PROPERTIES_DRAW_MAP,
  ucFirst,
  uppercaseFirstLetter,
} from "~/utils";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const PropertiesForm = ({ properties, control, register, setValue }) => {
  const removePropertiesStyles = Object.entries(properties).filter(
    ([key]) =>
      !GEOJSON_STYLES.concat(LEGEND_KEY)
        .concat(PROPERTIES_DRAW_MAP)
        .includes(key)
  );

  const { search: searchParam } = useLocation();
  const tipeQuery = new URLSearchParams(searchParam).get("tipe");
  const { desa } = useSelector((state) => state.Auth);

  const isMapDasar = [
    "desa",
    desa?.hierarki?.jenis_subdesa?.toLowerCase(),
    desa?.hierarki?.jenis_subsubdesa?.toLowerCase(),
    "rw",
    "rt",
  ];

  return (
    <>
      {removePropertiesStyles.map(([key, value]) => {
        if (["luas", "keliling", "panjang"].includes(key?.toLowerCase())) {
          return (
            <FormGroup>
              <Label>{uppercaseFirstLetter(key)}</Label>
              <InputGroup>
                <Input
                  readOnly
                  name={key}
                  innerRef={register}
                  value={parseInt(value).toFixed(2)}
                />

                {key === "luas" ? (
                  <InputGroupAddon addonType="append">
                    <InputGroupText>
                      {" "}
                      {isMapDasar.includes(tipeQuery) ? "Ha" : "M2"}
                    </InputGroupText>
                  </InputGroupAddon>
                ) : (
                  <InputGroupAddon addonType="append">
                    <InputGroupText>km</InputGroupText>
                  </InputGroupAddon>
                )}
              </InputGroup>
            </FormGroup>
          );
        }

        if (key === "kepadatan_penduduk") {
          return (
            <FormGroup>
              <Label>{uppercaseFirstLetter(key)}</Label>

              <Input
                readOnly
                name={key}
                innerRef={register}
                value={parseInt(value).toFixed(2)}
              />
            </FormGroup>
          );
        }

        if (key === properties?.klasifikasi_atribut_name) {
          return (
            <FormGroup>
              <Label>{uppercaseFirstLetter(key)}</Label>
              <Input
                readOnly
                name={key}
                innerRef={register}
                value={properties?.[properties?.klasifikasi_atribut_name]}
              />
            </FormGroup>
          );
        }

        return (
          <FormGroup>
            <Label>{uppercaseFirstLetter(key)}</Label>
            <Input
              readOnly
              name={key}
              innerRef={register}
              value={ucFirst(String(value))}
              // readOnly={key?.toLowerCase() === "desa"}
            />

            {key?.toLowerCase() === "nama" && (
              <FormText>
                <i className="mdi mdi-information-outline mr-1" />
                merupakan field yang terlihat di awal layer.
              </FormText>
            )}
          </FormGroup>
        );
      })}
    </>
  );
};

PropertiesForm.propTypes = {
  control: PropTypes.func,
  register: PropTypes.func,
  properties: PropTypes.object,
};

export default PropertiesForm;
